import { iconChevronDown, iconCircleUserRound } from "@kensho/icons";
import { Button, DropdownMenu } from "@kensho/neo";
import { use, useState } from "react";
import { useNavigate } from "react-router";

import { SiteAnalyticsContext } from "../providers/site-analytics-context";
import { UserContext } from "../providers/user-context";
import { SignInDialog } from "./sign-in-dialog";

export function UserInfo() {
  const { user, logout } = use(UserContext);

  const [signInOpen, setSignInOpen] = useState(false);

  const analytics = use(SiteAnalyticsContext);

  const navigate = useNavigate();

  return (
    <>
      {user?.email ? (
        <DropdownMenu
          items={[
            {
              id: "account",
              label: "Account",
              onAction() {
                navigate(`/account`);
                analytics.sendEvent("view_account_details");
              },
            },
            {
              id: "logout",
              label: "Log out",
              onAction() {
                logout();
                analytics.sendEvent("logout");
              },
            },
          ]}
          position="bottom"
        >
          <Button
            minimal
            icon={iconCircleUserRound}
            rightIcon={iconChevronDown}
          >
            Hi {user?.email}
          </Button>
        </DropdownMenu>
      ) : (
        <Button minimal onClick={() => setSignInOpen(true)}>
          Sign in
        </Button>
      )}
      <SignInDialog isOpen={signInOpen} onClose={() => setSignInOpen(false)} />
    </>
  );
}
